import { type Moment } from "moment"
import { type IServiceProviderDate } from "@/interfaces/api/service-provider-date.interface"
import { BaseModelWithFiles } from "@/models/base-with-files.model"
import { KnownBusinessEntityContact } from "@/models/known-business-entity-contact.model.ts"
import { ModelFactory } from "@/factories/model-factory"

export class ServiceProviderDate extends BaseModelWithFiles implements IServiceProviderDate {
  public static className = "ServiceProviderDate"
  public static verboseName = "Dienstverlenerdatum"

  public static override managedResolveFields = ["serviceProvider"]

  // isExpanded is a user-specific field that should not be updated.
  public static updateIgnoreFields: string[] = ServiceProviderDate.extendUpdateIgnoreFields([
    "isExpanded"
  ])

  id?: string

  serviceProvider: KnownBusinessEntityContact

  date: Moment

  isPublished: boolean
  nextWeekday?: Moment
  hasTentativeRecurringInstructions: boolean

  /** Whether the service provider date is expanded. */
  isExpanded: boolean

  purchaseTimeStart?: Moment
  purchaseTimeEnd?: Moment
  saleTimeStart?: Moment
  saleTimeEnd?: Moment
  kilometerTollSourceText: string

  constructor(serviceProviderDate: IServiceProviderDate, managed = false) {
    super(serviceProviderDate, managed)

    this.id = serviceProviderDate.id
    this.serviceProvider = ModelFactory.childModel(
      KnownBusinessEntityContact,
      serviceProviderDate.serviceProvider,
      managed
    )
    this.date = serviceProviderDate.date
    this.isPublished = serviceProviderDate.isPublished
    this.nextWeekday = serviceProviderDate.nextWeekday
    this.isExpanded = serviceProviderDate.isExpanded ?? true // Default to true.
    this.purchaseTimeStart = serviceProviderDate.purchaseTimeStart
    this.purchaseTimeEnd = serviceProviderDate.purchaseTimeEnd
    this.saleTimeStart = serviceProviderDate.saleTimeStart
    this.saleTimeEnd = serviceProviderDate.saleTimeEnd
    this.kilometerTollSourceText = serviceProviderDate.kilometerTollSourceText ?? ""
    this.hasTentativeRecurringInstructions = serviceProviderDate.hasTentativeRecurringInstructions
  }
}
